import { Component, EventEmitter, computed, isDevMode, OnDestroy, OnInit, Output } from '@angular/core';
import { AuthStateSignalsService } from '../../services/auth-state-signals.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-side-nav',
  standalone: false,
  templateUrl: './side-nav.component.html',
  styleUrl: './side-nav.component.scss'
})
export class SideNavComponent implements OnInit, OnDestroy {
  @Output() sidebarToggled = new EventEmitter<boolean>();

  collapsed = false;

  isDev = false;

  // User identity is derived reactively from the auth signals so the sidebar
  // updates immediately on login/logout/auth completion (no page refresh needed).
  userName = computed(() => this.auth.claims()?.name ?? '');
  userEmail = computed(() => this.auth.claims()?.email ?? '');
  userInitials = computed(() => {
    const name = this.auth.claims()?.name;
    if (!name) return '';
    const names = name.split(',').map(n => n.trim());
    if (names.length >= 2) {
      return (names[0][0] + names[names.length - 1][0]).toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
  });

  // Re-check auth state when the window regains focus. After the MSAL sign-in
  // popup closes, focus returns to the app window, so this reliably refreshes
  // the sign-in state right after the popup "blink" completes.
  private readonly onWindowFocus = () => this.auth.refreshAuthState();

  constructor(public auth: AuthStateSignalsService) {
    this.isDev = isDevMode();
  }

  toggleSidebar() {
    this.collapsed = !this.collapsed;
    this.sidebarToggled.emit(this.collapsed);
  }

  ngOnInit(): void {
    // The auth service runs its first check at construction, which can happen
    // before MSAL finishes authenticating on a fresh load. Re-check here and on
    // every window focus so the sidebar reflects the real state without a refresh.
    this.auth.refreshAuthState();
    window.addEventListener('focus', this.onWindowFocus);
  }

  ngOnDestroy(): void {
    window.removeEventListener('focus', this.onWindowFocus);
  }

  login() {
    this.auth.signIn().subscribe();
  }

  logout() {
    this.auth.signOut().subscribe();
  }

  openPowerBiReport() {
    window.open(environment.powerBiReportUrl, '_blank', 'noopener,noreferrer');
  }

}
